export const FETCH_GOOGLE_REVIEWS = "FETCH_GOOGLE_REVIEWS";
export const SET_GOOGLE_REVIEWS = "SET_GOOGLE_REVIEWS";
export const SET_BOOKING_MODEL = "SET_BOOKING_MODEL";
export const RESET_BOOKING_MODEL = "RESET_BOOKING_MODEL";
export const SET_CLIENT_SECRET = "SET_CLIENT_SECRET";
export const SUBMIT_CONTACT_FORM = "SUBMIT_CONTACT_FORM";
export const SUBMIT_APPOINTMENT_FORM = "SUBMIT_APPOINTMENT_FORM";
